import IPage from "../../../interfaces/page";
import TermsComponent from "../../Components/Terms/Terms.component";
import MainLayout from "../../layouts/Main/Main.layout";

const TermsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <MainLayout component={TermsComponent} />
}

export default TermsPage;